import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-030f70e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-item" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { style: {"padding-bottom":"0.4rem"} }
const _hoisted_4 = {
  title: "Select a date for confirmed ledger tranfers",
  class: "search-with-button"
}
const _hoisted_5 = {
  class: "date-picker",
  style: {"width":"50%"}
}
const _hoisted_6 = ["disabled"]

import { ref, computed } from "vue";
import DatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import PaymentItem from "@/Interfaces/Payments/ServiceInvoicePaymentItem";
import Popup from "./Popup.vue";
import CurrencyInput from "./CurrencyInput.vue";
import { confirmServiceInvoicePayment as confirmPayment } from "@/services/network";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import { authService } from "@/auth/authSingleton";
import DateIgnoreTime from "@/types/DateIgnoreTime";
import {
    MarketCurrency,
    MonetaryValueWithCommas,
    marketSelection,
} from "@/services/helpers/Helper";
import { IConfirmServiceInvoicePaymentItems } from "@/Interfaces/Payments/IConfirmServiceInvoicePaymentRequest";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceInvoicePaymentPopUp',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const selectedRows = computed({
    get() {
        return props.modelValue;
    },
    set(val) {
        emits("update:modelValue", val);
    },
});
const working = ref(false);
const selectedDate = ref<Date>();
const textInputOptions = { format: "yyyy/MM/dd" };
const paymentAmount = ref("");
const emits = __emit;
const sumOfBalances = computed(() => {
    return selectedRows.value!.reduce((total, obj) => total + parseFloat(obj.balance), 0);
});

function closeChild() {
    selectedDate.value = undefined;
    paymentAmount.value = "";
    selectedRows.value = undefined;
}
const FormatDatePicker = (date: Date) => {
    return date.toLocaleString("sv-SE").split(" ")[0].replaceAll("-", "/");
};
async function ConfirmTransfer() {
    if (working.value) return;
    working.value = true;
    const closeSpinner = useSpinnerPopup().show();
    try {
        if (!selectedRows.value)
            throw new ReferenceError(
                "selectedRow cannot be null when submitting the form"
            );

        const paymentItems: IConfirmServiceInvoicePaymentItems[] = selectedRows.value.map((row) => ({
                invoiceId: row.invoiceId,
                amountTotal: row.amountTotal,
                amountVAT: row.amountVAT,
                periodDateFrom: row.periodDateFrom,
                periodDateTo: row.periodDateTo,
                periodMonth: row.periodMonth,
                issueDate: row.issueDate,
                dueDate: row.dueDate,
                balance: row.balance,
                amountPaid: selectedRows.value?.length === 1 ? paymentAmount.value : row.balance,
            })
        );

        const payload = Object.assign({
            serviceInvoiceItems: paymentItems,
            userEmail: authService.getEmailAddress(),
            balanceDateUpdated: new DateIgnoreTime(selectedDate.value),
            market: marketSelection.value,
        });
        const response = await confirmPayment.put(payload);
        useNotifierWithErrFormatter().success({
            msg: "Payment successfully registered.",
        });
        closeChild();
        emits("confirm");
    } catch (error) {
        useNotifierWithErrFormatter().error({
            name: `${__filename}/${ConfirmTransfer.name}`,
            errorType: "Confirming payment",
            error,
        });
    } finally {
        closeSpinner();
        working.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: !!selectedRows.value,
    "onUpdate:modelValue": closeChild,
    title: "Payment confirmation",
    hasClose: ""
  }, _createSlots({ _: 2 }, [
    (selectedRows.value)
      ? {
          name: "contents",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createTextVNode(" The remaining balance on " + _toDisplayString(`${selectedRows.value.length == 1 ? 'this service invoice is:' : 'these service invoices are:'}`) + " ", 1),
              _createElementVNode("strong", null, _toDisplayString(_unref(MarketCurrency)[selectedRows.value[0].market]) + " " + _toDisplayString(_unref(MonetaryValueWithCommas)(sumOfBalances.value)), 1)
            ]),
            _createElementVNode("form", {
              class: "top-content",
              onSubmit: _withModifiers(ConfirmTransfer, ["prevent"])
            }, [
              _createElementVNode("span", _hoisted_3, "Select a payment date " + _toDisplayString(`${selectedRows.value.length == 1 ? "and an amount" : ""}`) + ":", 1),
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(DatePicker), {
                    modelValue: selectedDate.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
                    type: "date",
                    "enable-time-picker": false,
                    format: FormatDatePicker,
                    placeholder: "Select Date...",
                    "text-input-options": textInputOptions,
                    "text-input": "",
                    "max-date": new Date(),
                    teleport: true,
                    required: ""
                  }, null, 8, ["modelValue", "max-date"])
                ]),
                (selectedRows.value.length == 1)
                  ? (_openBlock(), _createBlock(CurrencyInput, {
                      key: 0,
                      modelValue: paymentAmount.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((paymentAmount).value = $event)),
                      max: selectedRows.value[0].balance,
                      min: 0.01,
                      currency: _unref(MarketCurrency)[selectedRows.value[0].market],
                      style: {"border-radius":"0"},
                      required: ""
                    }, null, 8, ["modelValue", "max", "currency"]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  disabled: working.value,
                  class: "right-button"
                }, "Confirm", 8, _hoisted_6)
              ])
            ], 40, _hoisted_2)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue"]))
}
}

})